export const useSxStyles = () => {
  return {
    addDiv: {
      height: '28px',
      padding: '6px',
      fontSize: '14px',
      '&:hover': {
        backgroundColor: '#d0d0d7',
        cursor: 'pointer',
      },
    },
    button: {
      float: 'right',
      marginRight: '8px',
    },
    buttonText: {
      margin: '2px 4px 2px 2px',
      fontWeight: '400',
    },
    tooltip: {
      padding: 0,
      border: '1px solid rgba(0, 0, 0, .15)',
      boxShadow: '0 6px 12px rgb(0 0 0 / 18%)',
      margin: 0,
      backgroundColor: '#fff',
      color: '#333',
    },
  };
};
